import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Electrical() {
	return (
		<div>
			<NeonHero
				title="Electrical"
				subtitle="Rapid fault isolation, module programming, sensor/camera replacements, and harness repair."
				primaryCta={{ label: 'Diagnose Issue', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">Includes</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Advanced OBD scanning and oscilloscope testing</li>
					<li>Battery, alternator, starter systems</li>
					<li>CAN bus diagnostics and module replacement</li>
					<li>ADAS sensors and camera systems</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Digital intake and symptom report</li>
							<li>Electrical testing and localization</li>
							<li>Repair/replace and coding/calibration</li>
							<li>Validation and documentation</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Affirm/Klarna options available at checkout.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Diagnostics same-day; parts-dependent repairs 1–3 days.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
